/***
 * @Author: hippo
 * @Date: 2025-01-15 15:39:31
 * @LastEditors: hippo
 * @LastEditTime: 2025-01-15 16:17:31
 * @Description: 
 * @
 */
import React, { useEffect } from "react";
import Qs from "qs"; // 引入 qs 库

const QRConnectCallback = () => {
  useEffect(() => {
    // 解析 URL 参数
    const query = Qs.parse(window.location.search.slice(1));
    const commKey = query.state || "qr_connect_comm_key";
    try {
      // 向父窗口发送消息
      window.parent.postMessage("tkn:" + query.tkn, "*");
    } catch (e) {
      console.error(e);
    }
  }, []);

  return (
    <div style={styles.loading}>正在登录 ...</div>
  );
};

// 样式
const styles = {
  loading: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily:
      '"Open Sans", "PingFang SC", "Microsoft YaHei", "Helvetica Neue", "Hiragino Sans GB", "WenQuanYi Micro Hei", Arial, sans-serif',
  },
};

export default QRConnectCallback;